export const parts = {
  allCodeSnippets: 'all-code-snippets',
  allPropertiesConfigurator: 'all-properties-configurator',
  configurators: 'configurators',
  content: 'content',
  cssPropertiesCodeSnippet: 'css-properties-code-snippet',
  cssPropertiesConfigurator: 'css-properties-configurator',
  input: 'input',
  propertiesCodeSnippet: 'properties-code-snippet',
  propertiesConfigurator: 'properties-configurator',
  select: 'select',
  slot: 'slot',
} as const;

export const reallyCodeConfiguratorLocalName =
  'really-code-configurator' as const;
